var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCustomCheckboxChecked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 2H2V14H14V2ZM0 0V16H16V0H0Z",
    fill: "#101010"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9903 6.37076L7.02132 12L3 8.20757L4.51163 6.78198L7.07946 9.20366L11.5465 5L13 6.37076H12.9903Z",
    fill: "#101010"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCustomCheckboxChecked);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/custom-checkbox-checked.9ca395dafa4b763790bb7f102baabd63.svg";